export const colors = {
    // for button colors , headings and navbar items of header
    // "header" : "#05386b"
    "yellow" : "#f8d424",
    "green" : "#39b54a"
}